import * as React from "react";
function SvgVideo(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M21 16l-10-6v12l10-6z" />
      <path d="M30 26H2V6h28zm2-26H0v32h32zm-6 2h4v2h-4zm-8 0h4v2h-4zm-8 0h4v2h-4zM2 2h4v2H2zm4 28H2v-2h4zm8 0h-4v-2h4zm8 0h-4v-2h4zm8 0h-4v-2h4z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgVideo);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
